import {Platform, TouchableOpacity} from "react-native";
import {
    Inline,
    Heading as PatronHeading,
    Stack,
    Text,
    usePatronTheme,
    View,
} from "@unibuddy/patron";
import {IconChevronDown} from "@unibuddy/icons";
import {boldFontStyles} from "../Styles/fontStyles";
import {useModal} from "../General/ModalProvider/ModalProvider";
import {AmboInboxCommunities} from "./AmboInboxCommunities";
import {useCommunity} from "../Community/CommunityProvider/CommunityProvider";
import {useNavigate} from "../Hooks/useNavigate";
import {Routes} from "../constants";

export const enum AmboInboxHeaderStrings {
    Title = "Chats",
    ChangeInbox = "Change inbox",
}

// `Heading` from patron overrides the `font-family` prop
// which is required on android to properly render bold text
// as opposed to the `weight` prop on iOS
const Heading = ({children}: {children: string}) => {
    if (Platform.OS === "web") {
        return <PatronHeading level="4">{children}</PatronHeading>;
    }

    return (
        <Text
            style={{
                ...boldFontStyles,
            }}
            size="xlarge"
        >
            {children}
        </Text>
    );
};

export type AmboInboxHeaderProps = {
    showUniversalInbox: boolean;
    setShowUniversalInbox: (show: boolean) => void;
};

export const AmboInboxHeader = ({
    showUniversalInbox,
    setShowUniversalInbox,
}: AmboInboxHeaderProps) => {
    const {openModal} = useModal();
    const {selectedCommunity} = useCommunity();
    const {navigate} = useNavigate();
    const theme = usePatronTheme();

    const redirectToRoot = () => {
        navigate({
            path: Routes.ROOT,
        });
    };

    const handleOpenFilter = () => {
        openModal({
            component: (
                <AmboInboxCommunities
                    showUniversalInbox={showUniversalInbox}
                    setShowUniversalInbox={setShowUniversalInbox}
                    redirectToRoot={redirectToRoot}
                />
            ),
        });
    };

    return (
        <View paddingX="medium" paddingY="small-medium" borderBottomWidth={1} borderColor="grey100">
            <TouchableOpacity
                onPress={handleOpenFilter}
                accessibilityRole="button"
                accessibilityLabel={AmboInboxHeaderStrings.ChangeInbox}
            >
                <Stack space="small">
                    <Inline space="xsmall" verticalAlign="top">
                        <Heading>{AmboInboxHeaderStrings.Title}</Heading>
                    </Inline>
                    <Inline space="xsmall" verticalAlign="top">
                        <Text color="grey600" numberOfLines={1} truncate>
                            {showUniversalInbox ? "All" : selectedCommunity?.title}
                        </Text>
                        <IconChevronDown height={15} width={15} color={theme.colors?.grey600} />
                    </Inline>
                </Stack>
            </TouchableOpacity>
        </View>
    );
};
